import Vue from 'vue'
import {
    Button,
    Divider,
    Image,
    Tabs,
    TabPane,
} from 'element-ui'

Vue.use(Button);
Vue.use(Divider);
Vue.use(Image);
Vue.use(Tabs);
Vue.use(TabPane);


